export { default } from "../[companySlug]/customer-portal";
export { getServerSideProps } from "../[companySlug]/customer-portal";
